
import Vue from 'vue'
import VueRouter from 'vue-router'

import loanpage from  "../views/loanpage.vue"
import loanindex from "../views/loan/index.vue"
import loginhome from "../views/loan/loginhome.vue"
import privacidad from "../views/loan/privacidad.vue"
import provision from "../views/loan/provision.vue"
import loginverify from "../views/loan/loginverify.vue"
import loginpassword from "../views/loan/loginpassword.vue"
import setpassword from "../views/loan/setpassword.vue"
import applyhome from "../views/loan/applyhome.vue"
import applywork from "../views/loan/applywork.vue"
import applyperson from "../views/loan/applyperson.vue"
import applycontacts from "../views/loan/applycontacts.vue"
import applyidcard from "../views/loan/applyidcard.vue"
import applybank from "../views/loan/applybank.vue"
import livingverify from "../views/loan/livingverify.vue"
import userstate from "../views/loan/userstate.vue"
import firstloan from "../views/loan/firstloan.vue"
import reapeatloan from "../views/loan/reapeatloan.vue"
import loanstatus from "../views/loan/loanstatus.vue"
import confirmloan from "../views/loan/confirmloan.vue"
import repayment from "../views/loan/repaymentnext.vue"
import usercenter from "../views/loan/usercenter.vue"
import orderlist from "../views/loan/orderlist.vue"
import loanagreement from "../views/loan/loanagreement.vue";

import { getAccessToken } from '@/utils/auth' // getToken from cookie

Vue.use(VueRouter);

const routes = [
    {
        path: '/',
        redirect: "/home",
    },
    {
        path: '/home',
        name: 'home',
        component: loanindex
    },
    {
        path: '/loanpage',
        name: 'loanpage',
        component: loanpage,
        redirect: '/loanpage/index',
        children: [
            {
                path: '/loanpage/index',
                name: 'loanindex',
                component: loanindex,
                meta: {
                    title: 'Superapoyomax'
                }
            },
            {
                path: '/loanpage/loginhome',
                name: 'loginhome',
                component: loginhome,
                meta: {
                    title: 'Superapoyomax'
                }
            },
            {
                path: '/loanpage/privacidad',
                name: 'privacidad',
                component: privacidad,
                meta: {
                    title: 'Superapoyomax'
                }
            },
            {
                path: '/loanpage/provision',
                name: 'provision',
                component: provision,
                meta: {
                    title: 'Superapoyomax'
                }
            },
            {
                path: '/loanpage/loginverify',
                name: 'loginverify',
                component: loginverify,
                meta: {
                    title: 'Superapoyomax'
                }
            },
            {
                path: '/loanpage/setpassword',
                name: 'setpassword',
                component: setpassword,
                meta: {
                    title: 'Superapoyomax'
                }
            },
            {
                path: '/loanpage/loginpassword',
                name: 'loginpassword',
                component: loginpassword,
                meta: {
                    title: 'Superapoyomax'
                }
            },
            {
                path: '/loanpage/applyhome',
                name: 'applyhome',
                component: applyhome,
                meta: {
                    title: 'Superapoyomax'
                }
            },
            {
                path: '/loanpage/applywork',
                name: 'applywork',
                component: applywork,
                meta: {
                    title: 'Superapoyomax'
                }
            },
            {
                path: '/loanpage/applyperson',
                name: 'applyperson',
                component: applyperson,
                meta: {
                    title: 'Superapoyomax'
                }
            },
            {
                path: '/loanpage/applycontacts',
                name: 'applycontacts',
                component: applycontacts,
                meta: {
                    title: 'Superapoyomax'
                }
            },
            {
                path: '/loanpage/applyidcard',
                name: 'applyidcard',
                component: applyidcard,
                meta: {
                    title: 'Superapoyomax'
                }
            },
            {
                path: '/loanpage/applybank',
                name: 'applybank',
                component: applybank,
                meta: {
                    title: 'Superapoyomax'
                }
            },
            {
                path: '/loanpage/livingverify',
                name: 'livingverify',
                component: livingverify,
                meta: {
                    title: 'Superapoyomax'
                }
            },
            {
                path: '/loanpage/userstate',
                name: 'userstate',
                component: userstate,
                meta: {
                    title: 'Superapoyomax'
                }
            },
            {
                path: '/loanpage/firstloan',
                name: 'firstloan',
                component: firstloan,
                meta: {
                    title: 'Superapoyomax'
                }
            },
            {
                path: '/loanpage/reapeatloan',
                name: 'reapeatloan',
                component: reapeatloan,
                meta: {
                    title: 'Superapoyomax'
                }
            },
            {
                path: '/loanpage/loanstatus',
                name: 'loanstatus',
                component: loanstatus,
                meta: {
                    title: 'Superapoyomax'
                }
            },
            {
                path: '/loanpage/confirmloan',
                name: 'confirmloan',
                component: confirmloan,
                meta: {
                    title: 'Superapoyomax'
                }
            },
            {
                path: '/loanpage/repayment',
                name: 'repayment',
                component: repayment,
                meta: {
                    title: 'Superapoyomax'
                }
            },
            {
                path: '/loanpage/usercenter',
                name: 'usercenter',
                component: usercenter,
                meta: {
                    title: 'Superapoyomax'
                }
            },
            {
                path: '/loanpage/orderlist',
                name: 'orderlist',
                component: orderlist,
                meta: {
                    title: 'Superapoyomax'
                }
            },
            {
                path: '/loanpage/loanagreement',
                name: 'loanagreement',
                component: loanagreement,
                meta: {
                    title: 'Superapoyomax'
                }
            }
        ]

    }
];

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes
});

const whiteList = [
    '/',
    '/home',
    '/about',
    '/policy',
    '/notice',
    '/help',
    '/loan',
    '/Equipo',
    '/Producto',
    '/Finanza',
    '/Privacidad',
    '/transparenciaOne',
    '/transparenciaTwo',
    '/transparenciaThree',
    '/loanpage/index',
    '/loanpage/loginhome',
    '/loanpage/privacidad',
    '/loanpage/provision',
    '/loanpage/loginverify',
    '/loanpage/setpassword',
    '/loanpage/loginpassword',
    /*'/loanpage/applyhome',
    '/loanpage/applywork',
    '/loanpage/applyperson',s
    '/loanpage/applycontacts',
    '/loanpage/applyidcard',
    '/loanpage/applybank',
    '/loanpage/livingverify',
    '/loanpage/userstate',
    '/loanpage/firstloan',
    '/loanpage/reapeatloan',
    '/loanpage/loanstatus',
    '/loanpage/repayment',
    '/loanpage/usercenter',*/

];

router.beforeEach((to, from, next) => {
    if (to.meta.title) {
        document.title = to.meta.title
    }

    try {
        // 判断是否登录状态
        const accessToken = getAccessToken();
        /*const isRepeatLoan = getIsRepeatLoan();

        const useisRepeatLoan = isRepeatLoan == 'false' ? false : true;*/

        const isValid = Boolean(accessToken);
        console.log(39999)
        if (isValid) {
            if (to.path == '/loanpage/index') {
                //next({ path: '/loanpage/index'})
                next();
            } else {
                console.log('前往新的页面');
                console.log(to.path)
                next()
            }
        } else {
            if (whiteList.indexOf(to.path) !== -1) { // 在免登录白名单，直接进入
                next()
            } else {
                next({ path: '/loanpage/index' })
            }
        }
    } catch (error) {
        window._error = error;
        next({ path: '/loanpage/index' })
    }
});

export default router